<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="9">
                <v-row dense>
                    <v-col cols="12" sm="12">

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="N° Documento *" v-model="obModal.nroDocumento" outlined dense
                                    color="textbox" disabled />
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field label="Nombres *" v-model="obModal.nombre" outlined dense color="textbox"
                                    :rules="_.concat(requeridoRegla,letrasRegla)" :disabled="isCedula" />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Teléfono Celular *" v-model="obModal.celular" outlined dense
                                    color="textbox" v-mask="'##########'"
                                    :rules="_.concat(requeridoRegla,_.size(obModal.celular) > 0 ? soloNumerosRegla(10,obModal.celular,10) : [])" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Teléfono Convencional *" v-model="obModal.telefonoPbx" outlined
                                    dense color="textbox" :rules="_.concat(requeridoRegla,telefono)" v-mask="'#########'" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Género *" color="textbox" v-model="obModal.idSexo"
                                    item-value="idGenero" item-text="genero" :disabled="isCedula"
                                    :items="_.filter(listGeneral.listGenero,{'visualiza':'true'})" outlined dense />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-autocomplete label="Estado Civil *" color="textbox" v-model="obModal.idEstadoCivil"
                                    item-value="idEstadoCivil" item-text="estado" :disabled="isCedula"
                                    :items="_.filter(listGeneral.listEstadoCivil,{'visualiza':'true'})" outlined dense
                                    :rules="requeridoRegla" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-dialog ref="fechaMat" v-model="openFecMat"
                                    :return-value.sync="obModal.fechaMatrimonio" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="obModal.fechaMatrimonio"
                                            label="Fecha Matrimonio " prepend-inner-icon="event" readonly outlined
                                            dense v-on="on" :disabled="isCedula" />
                                    </template>
                                    <v-date-picker color="primary" v-model="obModal.fechaMatrimonio" scrollable
                                        locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded color="danger" @click="openFecMat = false"
                                            v-html="'Salir'">
                                        </v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.fechaMat.save(obModal.fechaMatrimonio);"
                                            v-html="'Guardar Fecha'">
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Cónyuge " v-model="obModal.nombreConyugue" outlined dense
                                    color="textbox" :disabled="isCedula" />
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>

            </v-col>
            <v-col cols="12" sm="3">
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <div v-if="_.size(obModal.fotografia) > 0">
                            <v-img :src="obModal.fotografia" height="130" contain max-height="130" ></v-img>
                        </div>
                        <div class="text-center">
                            <input type="file" name="" id="fotografia" style="display:none" @change="loadFotografia($event,'fotografia')">
                            <v-tooltip top color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small color="primary" v-show="!isCedula" 
                                        v-on="on" @click="openInput('fotografia')">
                                        <v-icon dark>add_a_photo</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cargar Imagen</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field label="Dirección *" v-model="obModal.direccion" outlined dense color="textbox"
                    :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field label="Email *" v-model="obModal.email" outlined dense color="textbox"
                    :rules="_.concat(requeridoRegla,emailRegla)" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="4">
                <v-text-field label="Nacionalidad *" v-model="obModal.nacionalidad" outlined dense
                    color="textbox" :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field label="Lugar de Nacimiento *" v-model="obModal.lugarNacimiento" outlined dense
                    color="textbox" :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-dialog ref="fechaNac" v-model="openFecNac" :return-value.sync="obModal.fechaNacimiento" persistent
                    width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field color="textbox" v-model="obModal.fechaNacimiento" label="Fecha Nacimiento *"
                            prepend-inner-icon="event" readonly outlined dense v-on="on" :disabled="isCedula"
                            :rules="requeridoRegla" />
                    </template>
                    <v-date-picker color="primary" v-model="obModal.fechaNacimiento" scrollable locale="es">
                        <v-spacer></v-spacer>
                        <v-btn outlined dense rounded color="danger" @click="openFecNac = false" v-html="'Salir'">
                        </v-btn>
                        <v-btn rounded dark color="primary" @click="$refs.fechaNac.save(obModal.fechaNacimiento);"
                            v-html="'Guardar Fecha'">
                        </v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="4">
                <v-text-field label="Instrucción *" v-model="obModal.instruccion" outlined dense color="textbox"
                    :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field label="Profesión *" v-model="obModal.profesion" outlined dense color="textbox"
                    :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field label="N° de Casa *" v-model="obModal.nroCasa" outlined dense color="textbox"
                    :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="6">
                <v-autocomplete label="Provincia *" color="textbox" v-model="obModal.idProvincia"  
                    :items="listGeneral.listProvincia" outlined :disabled="isCedula"
                    dense :rules="requeridoRegla" @change="onListarCanton"/>
            </v-col>
            <v-col cols="12" sm="6">
                <v-autocomplete label="Cantón *" color="textbox" v-model="obModal.idCanton" item-value="idCanton"
                    item-text="canton" :items="listGeneral.listCanton" outlined :disabled="isCedula"
                    dense :rules="requeridoRegla"/>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field label="Nombre Padre *" v-model="obModal.nombrePadre" outlined dense color="textbox"
                    :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field label="Nombre Madre *" v-model="obModal.nombreMadre" outlined dense color="textbox"
                    :rules="requeridoRegla" :disabled="isCedula" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="4">
                <v-autocomplete label="Estado *" color="textbox" v-model="obModal.idEstado" item-value="id_estado"
                    item-text="nombre_estado" :items="_.filter(listGeneral.listEstado,{'visualiza':'true'})" outlined
                    dense :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="4">
                <div v-if="_.size(obModal.firma) > 0">
                    <v-img :src="obModal.firma" height="130" contain max-height="130" ></v-img>
                </div>
                <div class="text-center">
                    <input type="file" name="" id="firma" style="display:none" @change="loadFotografia($event,'firma')">
                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="primary" v-show="!isCedula" 
                                v-on="on" @click="openInput('firma')">
                                <v-icon dark>add_a_photo</v-icon>
                            </v-btn>
                        </template>
                        <span>Cargar Imagen</span>
                    </v-tooltip>
                </div>
            </v-col>
            <v-col cols="12" sm="4" />
        </v-row>

        <v-row dense>
            <v-col class="text-right">
                <v-btn outlined rounded class="mr-1" @click="onClose">Cancelar</v-btn>
                <v-btn rounded dark color="primary" @click="validar(1)">Guardar</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {
        mask
    } from 'vue-the-mask';
    export default {
        name: 'ModalClienteNaturalComponent',
        inject: ['onClose', 'validar'],
        directives: {
            mask
        },
        props: {
            isCedula: {
                type: Boolean,
                default: true
            },
            obModal: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            openFecNac: false,
            openFecMat: false,
        }),
        watch:{
            obModal:{
                handler(val){
                    if(this.isCedula && _.size(val.nroDocumento) >= 10 && _.size(val.lugarNacimiento) > 0){
                        this.onListarProvincia('L')
                            .then((r)=>{
                                this.onListarCanton('L');
                            })
                            .catch((e)=>{
    
                            })
                    }
                },
                deep:true
            }
        },
        methods:{
            onListarProvincia(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var s = _.split(this.obModal.lugarNacimiento,'/');
                    var o = {
                        opcion:'BUSCAR_X_NOMBRE_PROVINCIA',
                        provincia: _.get(s,'0',''),
                        idEstado: this.parametros.id_estado_default
                    }

                    return axios.post(`${BASE_URI}administrador/provincia/listar`,o)
                                .then((r)=>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                        this.obModal.idProvincia = r.data.data[0].value;
                                        return r;
                                })
                                .catch((e)=>{
                                    mensajesAlerta(e,error);
                                    return e;
                                });
                }
            },
            onListarCanton(event){
                if(!_.isUndefined(event)){
                    var error = 'E';

                    if(this.isCedula){
                        var s = _.split(this.obModal.lugarNacimiento,'/');
                        var o = {
                            opcion:'BUSCAR_X_NOMBRE_CANTON',
                            canton: _.get(s,'1',''),
                            idEstado: this.parametros.id_estado_default
                        }
                    }else{
                        var o = {
                            opcion:'L',
                            idProvincia:this.obModal.idProvincia,
                            idEstado: this.parametros.id_estado_default
                        }
                    }

                    axios.post(`${BASE_URI}administrador/canton/listar`,o)
                         .then((r)=>{
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                var l = r.data.data;
                                l = _.map(l,(v)=>{ 
                                    return {
                                        idCanton: !_.isUndefined(v.id_canton) && !_.isNull(v.id_canton) ? v.id_canton : v.idCanton,
                                        canton:v.canton
                                    }
                                 });

                                this.listGeneral.listCanton = l
                                if(this.isCedula)
                                    this.obModal.idCanton = l[0].idCanton;
                         })
                         .catch((e)=>{
                             mensajesAlerta(e,error);
                         });
                }
            },
            openInput(v){
                document.getElementById(v).click();
            },
            loadFotografia(event,v){
                if(!_.isUndefined(event)){
                    try {
                        var keysExt = ['png','jpeg','jpg'];
                        var file = _.get(event,['target','files','0'],'');
                        var ob = _.clone(this.obModal);

                        if(_.get(file,'size',0) == 0) throw mensajeEstandar.archivo;
                        var name = _.get(_.split(file.name,'.'),'1','');
                        
                        if(!_.includes(keysExt,name)) throw mensajeEstandar.archivo;

                            var fr = new FileReader();
                            fr.readAsDataURL(file);
                            fr.addEventListener('load', () => {
                                _.set(this.obModal,v,fr.result);
                                this.$forceUpdate();
                            });
                            
                            document.getElementById(v).value = '';
                    } catch (error) {
                        mensajesAlerta(error,'I');
                        document.getElementById(v).value = '';
                    }
                }
            }
        }
    }
</script>